import React from 'react';
import './Impressum.css';
import { localized } from '../config/localization';
import { getYear } from 'date-fns/getYear';

export const Impressum = () => {
  return (
    <div className="impressum">
      <div className="impressum__links">
        <a
          className="impressum__link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://blechcon.de/de/impressum.html"
        >
          {localized.IMPRINT}
        </a>
        <div className="impressum__and">{localized.AND}</div>
        <a
          className="impressum__link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://blechcon.de/de/datenschutz.html"
        >
          {localized.PRIVACY_POLICY}
        </a>
      </div>
      <div className="impressum__copyright">
        Blechcon {'\u00a9'}
        {getYear(new Date())}
      </div>
    </div>
  );
};
